import { useEffect, useState } from "react";
import { systemLogsService } from "app/services/SystemLogsService";

const ActivityLogs = () => {
    const [logs, setLogs] = useState([]);
    const [filters, setFilters] = useState({
        level: null,
        search: "",
    });
    const [lastDoc, setLastDoc] = useState(null);
    const [loading, setLoading] = useState(false);

    const load = async (append = false) => {
        setLoading(true);

        const res = await systemLogsService.fetchLogs({
            ...filters,
            lastDoc: append ? lastDoc : null,
        });

        setLogs((prev) => (append ? [...prev, ...res.items] : res.items));
        setLastDoc(res.lastDoc);

        setLoading(false);
    };

    // filtre değişince sıfırdan yükle
    useEffect(() => {
        load(false);
    }, [filters.level]);

    // client-side search
    const filteredRows = logs.filter((log) => {
        if (!filters.search) return true;
        const text = filters.search.toLowerCase();
        return (
            JSON.stringify(log.message || {}).toLowerCase().includes(text) ||
            JSON.stringify(log.context || {}).toLowerCase().includes(text)
        );
    });

    return (
        <div>
            <h2>Activity Logs</h2>

            {/* Filtreler */}
            <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
                <input
                    type="text"
                    placeholder="Search"
                    value={filters.search}
                    onChange={(e) =>
                        setFilters((f) => ({ ...f, search: e.target.value }))
                    }
                    style={{ flex: 1 }}
                />

                <select
                    value={filters.level || ""}
                    onChange={(e) =>
                        setFilters((f) => ({
                            ...f,
                            level: e.target.value || null,
                        }))
                    }
                >
                    <option value="">All Levels</option>
                    <option value="info">Info</option>
                    <option value="warning">Warning</option>
                    <option value="error">Error</option>
                </select>
            </div>

            {/* Tablo */}
            <table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Level</th>
                        <th>User</th>
                        <th>Context</th>
                        <th>Message</th>
                    </tr>
                </thead>

                <tbody>
                    {filteredRows.map((log) => (
                        <tr key={log.id}>
                            <td>{new Date(log.createdAt.seconds * 1000).toLocaleString()}</td>
                            <td>{log.level}</td>
                            <td>{log.userId}</td>
                            <td>
                                <pre style={{ margin: 0, fontSize: "12px" }}>
                                    {JSON.stringify(log.context || {}, null, 2)}
                                </pre>
                            </td>
                            <td>{JSON.stringify(log.message)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Load more */}
            {lastDoc && (
                <button disabled={loading} onClick={() => load(true)}>
                    {loading ? "Loading..." : "Load More"}
                </button>
            )}
        </div>
    );
};

export default ActivityLogs;
